/**
 * parcoursEvents.js
 *
 * Système d'événements découplé pour notifier le parcours
 * que la progression a changé (exercice complété, score sauvegardé, etc.).
 *
 * Les modules de storage (discoveryStorage, progressStorage) émettent l'événement.
 * Le ParcoursContext écoute et se rafraîchit automatiquement.
 */

const EVENT_NAME = 'parcours:progression-changed';

/**
 * Émet un événement de changement de progression.
 * Appelé depuis les fonctions de sauvegarde des différents modules.
 *
 * @param {string} source - Module émetteur ('discovery', 'rythmes', 'roulette', etc.)
 * @param {Object} detail - Détails optionnels (exerciseId, score, etc.)
 */
export function emitProgressionChanged(source, detail = {}) {
  window.dispatchEvent(new CustomEvent(EVENT_NAME, {
    detail: { source, timestamp: Date.now(), ...detail }
  }));
}

/**
 * Écoute les changements de progression.
 * @param {Function} callback - (event) => void
 * @returns {Function} Fonction de cleanup (pour useEffect)
 */
export function onProgressionChanged(callback) {
  window.addEventListener(EVENT_NAME, callback);
  return () => window.removeEventListener(EVENT_NAME, callback);
}
